import { useEffect, useState } from 'react';

import { ConnectionPointsData } from '../types/connectionPoints';
import { apiForms } from 'services/apiService';

export function useConnectionPointsData(fromUserId: string, toUserId: string) {
  const [data, setData] = useState<ConnectionPointsData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!fromUserId || fromUserId.trim() === '' || !toUserId || toUserId.trim() === '') {
      console.log('[useConnectionPointsData] IDs inválidos, não fazendo requisição:', {
        fromUserId,
        toUserId,
      });
      setData(null);
      setError(null);
      setLoading(false);
      return;
    }

    const fetchConnectionPoints = async () => {
      setLoading(true);
      setError(null);

      try {
        const url = `/v1/analysis/report/connection-points?from_user_uuid=${fromUserId}&to_user_uuid=${toUserId}`;
        console.log('[useConnectionPointsData] Fazendo requisição para:', url);

        const response = await apiForms.get(url);
        console.log('[useConnectionPointsData] Resposta recebida:', response.data);

        setData(response.data);
      } catch (err: any) {
        console.error('[useConnectionPointsData] Erro na requisição:', err);
        setError(err.message || 'Erro ao buscar pontos de conexão');
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchConnectionPoints();
  }, [fromUserId, toUserId]);

  return { data, loading, error };
}
